import type { Epic } from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { catchError, filter, mergeMap, of } from 'rxjs'
import { withLatestFrom } from 'rxjs/operators'

export const UpdateProjectEpic: Epic = (action$, state$, { [projectSlice.name]: project, ProjectRepository }) =>
  action$.pipe(
    filter(project.updateProjectRequest.match),
    withLatestFrom(state$),
    mergeMap(([action]) =>
      ProjectRepository.updateProject(action.payload.id, {
        name: action.payload.name,
        description: action.payload.description ?? '',
        ownerUser: action.payload.ownerUser,
        ...(action.payload.targetTaxonomy && { targetTaxonomy: action.payload.targetTaxonomy }),
        version: action.payload.version || '0',
        redlistMode: action.payload.redlistMode,
        groupingMode: action.payload.groupingMode,
        processingType: action.payload.processingType ?? null,
      }).pipe(
        mergeMap((response) => of(project.updateProjectRequestSuccess(response))),
        catchError((error) => of(project.updateProjectRequestFailure({ error })))
      )
    )
  )
